import { domGetAttr } from "../utils/dom";
import { processElementEvent } from "../events/element";
import { domEventTypes } from "../types/dom-events";
let mouseEnterTime;
const durationLimit = 2000;
export const handleMouseLeave = (event) => {
    const duration = Date.now() - mouseEnterTime;
    if (duration > durationLimit) {
        const domAttr = Object.assign(Object.assign({}, domGetAttr(event)), { interval: duration });
        processElementEvent(domAttr, domEventTypes.mouseleave);
    }
};
export const handleMouseEnter = (event) => (mouseEnterTime = Date.now());



//////////////////
// WEBPACK FOOTER
// ./~/@celine/passive-tracking/dist/element-handlers/hover.js
// module id = ./node_modules/@celine/passive-tracking/dist/element-handlers/hover.js
// module chunks = 0